import { render, staticRenderFns } from "./HotelsAdvancedDetailAdditionalPrices.vue?vue&type=template&id=77f1752b&scoped=true&"
import script from "./HotelsAdvancedDetailAdditionalPrices.vue?vue&type=script&lang=js&"
export * from "./HotelsAdvancedDetailAdditionalPrices.vue?vue&type=script&lang=js&"
import style0 from "./HotelsAdvancedDetailAdditionalPrices.vue?vue&type=style&index=0&id=77f1752b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f1752b",
  null
  
)

export default component.exports